import React from "react";
import { TaskType } from "./Types";
import { AtomInputTask } from "../atoms/AtomInputTask";
import { useAppState, useSelectedSession } from "../../state";
import ContentEditable, { ContentEditableEvent } from "react-contenteditable";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "../ItemTypes";

type TaskProps = {
  task: TaskType;
  isAdding?: boolean;
  index: number;
  onMoveTask: (dragIndex: number, hoverIndex: number) => void;
};

export const Task: React.FC<TaskProps> = ({ task, index, onMoveTask }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [, drop] = useDrop({
    accept: ItemTypes.TASK,
    hover(item: any, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      onMoveTask(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.TASK,
    item: { id: task.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  drag(drop(ref));
  const [, dispatch] = useAppState();
  const session = useSelectedSession();

  const handleCheckChange = () => {
    dispatch({
      type: "DELETE_TASK",
      payload: { sessionId: session.id, taskId: task.id },
    });
  };

  const handleDescriptionChange = (
    event: ContentEditableEvent
  ) => {
    dispatch({
      type: "SET_TASK_DESCRIPTION",
      payload: {
        sessionId: session.id,
        taskId: task.id,
        description: event.currentTarget.textContent || "",
      },
    });
  };

  const handleMinutesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (!isNaN(Number(inputValue))) {
      task.minutes = Number(event.target.value);
      dispatch({
        type: "SET_TASK_TIME",
        payload: { sessionId: session.id, taskId: task.id, time: task.minutes },
      });
    }
  };

  return (
    <div
      ref={ref}
      className={`task-item ${isDragging ? "opacity-50" : ""}`}
      style={{ cursor: "move" }}
     // {task content her}
    > 
    <div className="grid grid-cols-10 p-6 border border-gray-200 rounded-lg shadow hover:bg-gray-100 white:bg-gray-800 white:border-gray-700 white:hover:bg-gray-700">
      <div className="col-span-1 mt-auto mb-auto font-bold text-2sm">
        <input
          id="default-checkbox"
          type="checkbox"
          value=""
          className=""
          onChange={handleCheckChange}
        />
      </div>

      <div className="col-span-9">
        <div className="focus:outline-0 text-xl mr-auto">
          <AtomInputTask task={task} />
        </div>
        <ContentEditable
          html={task.description || ""}
          disabled={false}       // use true to disable editing
          onChange={handleDescriptionChange} // handle innerHTML change
          tagName='article' // Use a custom HTML tag (uses a div by default)
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              document.execCommand('insertLineBreak')
              event.preventDefault()
            }
          }}
          className="w-full bg-inherit border-none focus:outline-none resize-none whitespace-pre-line"
        />
        <div className="relative mr-auto font-normal bg-inherit border-none focus:outline-none">
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={task.minutes !== 0 ? task.minutes : ""}
            onChange={handleMinutesChange}
            className="bg-inherit border-none focus:outline-none"
          ></input>
        </div>
      </div>
    </div >
    </div>
  );
};
